import { useCompanyStore } from "../../../stores/useCompanyStore";
import api from "../../../util/api";
import { SubscriptionOptionEnum } from "@fena/toolkit-types";

export const useSubscriptionCheck = () => {
  const { company, setCompany } = useCompanyStore();

  const checkSubscription = async () => {
    try {
      const currentSubscriptionList = await api.getCurrentSubscriptions();
      const filtered = currentSubscriptionList?.data?.filter(
        (el: any) =>
          el?.details?.subscriptionOption ===
            SubscriptionOptionEnum.PAYMENTS_ONLY ||
          el?.details?.subscriptionOption === SubscriptionOptionEnum.TOOLKIT
      );

      const sorted = filtered?.sort(
        (a: any, b: any) =>
          new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
      );

      const currentSubscription = sorted?.[0];

      setCompany({
        ...company,
        currentSubscription,
      });
    } catch (error: any) {
      console.error("Error checking subscription status: ", error);
    }
  };

  return { checkSubscription };
};
